import { render, staticRenderFns } from "./WorkspaceSignatureTypeSetting.vue?vue&type=template&id=b335336e&scoped=true"
import script from "./WorkspaceSignatureTypeSetting.vue?vue&type=script&lang=js"
export * from "./WorkspaceSignatureTypeSetting.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSignatureTypeSetting.vue?vue&type=style&index=0&id=b335336e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b335336e",
  null
  
)

export default component.exports